import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Link, useSearchParams } from "react-router-dom";
import {
  CustomerFeedBackListOrderByDirectionOptions,
  CustomerFeedBackListOrderByOptions,
  FeedbacksFilter,
  getFeedbacksAsync,
  selectFeedbackItems,
  selectFeedbackItemsLoadingStatus,
  selectFeedbackPagination,
} from "./FeedBacksSlice";
import React, { useCallback, useEffect, useState } from "react";
import {
  InitialAllAccommodationsPaginationParameters,
  InitialPaginationParameters,
} from "../../types/pagination.types";
import { Rating } from "@lomarengas/design-system";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import Page from "../../types/Page";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { LOADING_STATUS } from "../../common/constants";
import { useAuthUser } from "../../features/auth/authHooks";
import DatePicker from "react-datepicker";
import { selectInputErrors } from "../../features/errors/errorsSlice";
import {
  AccommodationListItem,
  AccommodationQueryFilters,
  getAccommodationsAsync,
  selectAccommodationItems,
  selectAccommodationsLoadingStatus,
} from "../AccommodationsPage/accommodationsSlice";
import { DateRange } from "react-day-picker";
import { dateToDateOnlyString } from "../../common/misc";
import { PaginationComponent } from "../../components/PaginationComponent";
import { format } from "date-fns";
import LocalizedDatePicker from "../../components/DatePicker/LocalizedDatePicker";

const FeedBacksPageType: Page = {
  ActiveTab: "FeedBacks",
  DisplayName: "Palautteet",
  DisplayParentName: "",
  LinkUrl: "/feedbacks",
  Path: "/feedbacks",
  RouteName: "feedbacks",
};
const FeedBacksPage = () => {
  const dispatch = useAppDispatch();
  const { ownerAccountId } = useAuthUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const feedbackStateFromParams = searchParams.get("feedbackState");
  const startDateFromParams = searchParams.get("startDate");
  const endDateFromParams = searchParams.get("endDate");
  const accommodationIdFromParam = searchParams.get("accommodationId");
  const feedbackIdFromParam = searchParams.get("feedbackId");
  const [accommodationFiltering, setAccommodationFiltering] =
    useState<AccommodationQueryFilters>({
      PageNumber: InitialAllAccommodationsPaginationParameters.PageNumber,
      PageSize: InitialAllAccommodationsPaginationParameters.PageSize,
      filterCriteria: {
        showDeleted: false,
        searchString: undefined,
        accommodationNumber: undefined,
        novelty: undefined,
        showInWebShop: undefined,
        showInOwnerPage: undefined,
        accommodationGroupId: undefined,
        accountId: ownerAccountId,
      },
    });
  // Get today's date
  let today = new Date();
  let oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  if (startDateFromParams != null) {
    oneMonthAgo = new Date(startDateFromParams);
  }
  if (endDateFromParams != null) {
    today = new Date(endDateFromParams);
  }
  // Create a date object for tomorrow
  // const tomorrow = new Date();
  // tomorrow.setDate(today.getDate() + 1);
  const [dayPickerSelectedRange, setDayPickerSelectedRange] =
    useState<DateRange>({
      from: oneMonthAgo,
      to: today,
    });
  const [startDate, setStartDate] = useState(oneMonthAgo);
  const [endDate, setEndDate] = useState(today);
  const [
    accommodationDropdownSelectedAccommodation,
    setAccommodationDropdownSelectedAccommodation,
  ] = useState<string>(undefined);
  const inputErrors = useAppSelector(selectInputErrors);
  const accommodations = useAppSelector(selectAccommodationItems);

  const accommodationsLoadingStatus = useAppSelector(
    selectAccommodationsLoadingStatus,
  );
  const feedbackItems = useAppSelector(selectFeedbackItems);
  const feedbackItemsPagination = useAppSelector(selectFeedbackPagination);
  const feedbackItemsLoadingStatus = useAppSelector(
    selectFeedbackItemsLoadingStatus,
  );
  const [orderByField, setOrderByField] = useState(
    CustomerFeedBackListOrderByOptions.AnswerTime,
  );
  const initialFeedbacksFilter: FeedbacksFilter = {
    PageNumber: InitialPaginationParameters.PageNumber,
    PageSize: InitialPaginationParameters.PageSize,
    feedbackState: "Approved",
    accommodationId: null,
    ownerId: ownerAccountId,
    orderBy: CustomerFeedBackListOrderByOptions.BookingStartTime,
    FeedbackFetchAnswerStartDate: null,
    FeedbackFetchAnswerEndDate: null,
    OrderDirection: CustomerFeedBackListOrderByDirectionOptions.Descending,
  };

  const [feedbacksFilter, setFeedbacksFilter] = useState(
    initialFeedbacksFilter,
  );
  const initAccommodationsFetch = useCallback(() => {
    dispatch(getAccommodationsAsync(accommodationFiltering));
  }, [dispatch, ownerAccountId]);
  useEffect(() => {
    initAccommodationsFetch();
  }, [initAccommodationsFetch, ownerAccountId]);
  const doSearch = () => {
    const searchFilters: FeedbacksFilter = feedbacksFilter;
    searchParams.set("feedbackState", feedbacksFilter.feedbackState);

    searchFilters.ownerId = ownerAccountId;
    searchFilters.accommodationId = null;
    if (accommodationDropdownSelectedAccommodation != undefined) {
      searchFilters.accommodationId =
        accommodationDropdownSelectedAccommodation;
      searchParams.set(
        "accommodationId",
        accommodationDropdownSelectedAccommodation,
      );
    } else {
      searchParams.delete("accommodationId");
    }
    if (startDate != undefined) {
      searchFilters.FeedbackFetchAnswerStartDate = startDate;
      searchParams.set("startDate", format(startDate, "yyyy-MM-dd"));
    }
    if (endDate != undefined) {
      searchFilters.FeedbackFetchAnswerEndDate = endDate;
      searchParams.set("endDate", format(endDate, "yyyy-MM-dd"));
    }
    setSearchParams(searchParams);
    // searchFilters.feedbackState = feedbackStateSelect'New';
    dispatch(getFeedbacksAsync(searchFilters));
  };

  const HandlePaginationClick = (Page: number) => {
    const paginatedFiltering = feedbacksFilter;
    paginatedFiltering.PageNumber = Page;
    setFeedbacksFilter(paginatedFiltering);
    dispatch(getFeedbacksAsync(paginatedFiltering));
  };
  /*
  useEffect(() => {
    doSearch();
  }, []);
   */
  const accommodationDropdownChanged = (e: any) => {
    if (e.target.value != "0") {
      let selectedAccommodation = accommodations.find(
        (accommodation) => accommodation.id == e.target.value,
      );
      setAccommodationDropdownSelectedAccommodation(selectedAccommodation.id);
    } else {
      setAccommodationDropdownSelectedAccommodation(undefined);
    }
  };
  const setAccommodationDropdownDateRange = (
    startDateSelected: Date,
    endDateSelected: Date,
  ) => {
    let selectedRange = dayPickerSelectedRange;
    if (startDateSelected != undefined) {
      selectedRange.from = startDateSelected;
      setStartDate(startDateSelected);
      // Move enddate, if selected startdate is greater than endDate
      if (endDate < startDateSelected) {
        setEndDate(startDateSelected);
      }
    }
    if (endDateSelected != undefined) {
      selectedRange.to = endDateSelected;
      setEndDate(endDateSelected);
    }
    setDayPickerSelectedRange(selectedRange);
  };
  const selectFeedbackSearchStateChanged = (e) => {
    feedbacksFilter.feedbackState = e.target.value;
    // doSearch();
  };
  const renderFeedBacks = () => {
    return feedbackItems.map((feedback) => (
      <tr key={feedback.id}>
        <td scope="row">
          <Link
            to={"/feedbacks/details/" + feedback.id}
            className="text-nowrap"
          >
            <Rating Rating={feedback.rating * 0.5} CssClass="text-nowrap" />{" "}
            <span className="d-none ms-8">{feedback.rating * 0.5} / 5</span>
          </Link>
        </td>
        <td>
          <Link to={"/feedbacks/details/" + feedback.id}>
            {dateToDateOnlyString(new Date(feedback.bookingStartTime))}
            {" - "}
            {dateToDateOnlyString(new Date(feedback.bookingEndTime))}
          </Link>
        </td>
        <td>
          {feedback.accommodationNumber} {feedback.accommodationName}
        </td>
        <td>
          {feedback.customerFirstName} {feedback.customerLastName}
        </td>
        <td>{feedback.feedBackText}</td>
      </tr>
    ));
  };
  const tableHeaderClick = (orderBy: CustomerFeedBackListOrderByOptions) => {
    console.log(feedbacksFilter.OrderDirection);
    let filter = feedbacksFilter;
    if (
      filter.OrderDirection ==
      CustomerFeedBackListOrderByDirectionOptions.Ascending
    ) {
      filter.OrderDirection =
        CustomerFeedBackListOrderByDirectionOptions.Descending;
    } else {
      filter.OrderDirection =
        CustomerFeedBackListOrderByDirectionOptions.Ascending;
    }
    filter.orderBy = orderBy;
    setFeedbacksFilter(filter);
    doSearch();
  };
  if (feedbackItems == null) {
    return (
      <div className={FeedBacksPageType.RouteName}>
        <Layout CurrentPage={FeedBacksPageType}>
          <PageHeader
            Title={FeedBacksPageType.DisplayName}
            SubTitle={FeedBacksPageType.DisplayParentName}
            Back={false}
            Icon="send"
            Print={true}
          ></PageHeader>
          <Col xl={9}>
            Ladataan palautteita...
            <Spinner animation="border" />;
          </Col>
        </Layout>
      </div>
    );
  }
  return (
    <div className={FeedBacksPageType.RouteName}>
      <Layout CurrentPage={FeedBacksPageType}>
        <PageHeader
          Title={FeedBacksPageType.DisplayName}
          SubTitle={FeedBacksPageType.DisplayParentName}
          Back={false}
          Icon="send"
          Print={true}
        ></PageHeader>
        <div>
          <Row className="d-print-none gy-16">
            <Col>
              <Form.Label htmlFor="selectCabin">Palautteen tila</Form.Label> :
              <Form.Select
                aria-label="Palautteen tila"
                id="selectFeedbackSearchState"
                onChange={(e) => selectFeedbackSearchStateChanged(e)}
                defaultValue={feedbackStateFromParams}
              >
                <option value="Approved">Hyväksytty</option>
                <option value="PartiallyApproved">Osittain hylätty</option>
                <option value="Rejected">Hylätty</option>
              </Form.Select>
            </Col>
            <Col lg="3">
              <Form.Label htmlFor="selectCabin">Kohde</Form.Label>
              <Form.Select
                aria-label="Kohde"
                id="selectCabin"
                value={accommodationIdFromParam ?? 0} // controlled selection
                onChange={(e) => accommodationDropdownChanged(e)}
              >
                {accommodations.length > 1 && (
                  <option value={0}>Näytä kaikki kohteet</option>
                )}
                {accommodations
                  .slice() // clone so original array isn't mutated
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((accommodation) => (
                    <option key={accommodation.id} value={accommodation.id}>
                      {accommodation.name}, {accommodation.accommodationNumber}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            <Col lg="5">
              <Form.Label htmlFor="selectStart">Varauksen ajankohta</Form.Label>
              <div className="d-flex  gap-8 align-items-center">
                <div className="w-100 position-relative">
                  <LocalizedDatePicker
                    selected={startDate}
                    onChange={(date) =>
                      setAccommodationDropdownDateRange(date, undefined)
                    }
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    className="form-control"
                    dateFormat={"dd.MM.yyyy"}
                  />
                  <Button
                    variant="link"
                    className="pe-none position-absolute end-0 top-0"
                    id="button-addon2"
                  >
                    <span className="bi bi-calendar2-event"></span>
                  </Button>
                </div>
                <span className="bi bi-arrow-right"></span>
                <div className="w-100 position-relative">
                  <LocalizedDatePicker
                    selected={endDate}
                    onChange={(date) =>
                      setAccommodationDropdownDateRange(undefined, date)
                    }
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    className="form-control"
                    dateFormat={"dd.MM.yyyy"}
                  />
                  <Button
                    variant="link"
                    className="pe-none position-absolute end-0 top-0"
                    id="button-addon2"
                  >
                    <span className="bi bi-calendar2-event"></span>
                  </Button>
                </div>
              </div>
            </Col>
            <Col className="d-flex align-items-end">
              <Button
                onClick={() => doSearch()}
                variant="primary"
                className="mt-auto w-100"
              >
                Hae palautteet
              </Button>
            </Col>
          </Row>
          <p style={{ height: 32 }}>
            {feedbackItemsLoadingStatus != LOADING_STATUS.IDLE && (
              <>
                Ladataan palautteita...
                <Spinner animation="border" />
              </>
            )}
          </p>
          <table className="table mt-16 mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  onClick={() =>
                    tableHeaderClick(CustomerFeedBackListOrderByOptions.Rating)
                  }
                >
                  Arvio{" "}
                  {feedbacksFilter.orderBy ==
                    CustomerFeedBackListOrderByOptions.Rating && (
                    <>
                      {feedbacksFilter.OrderDirection ==
                        CustomerFeedBackListOrderByDirectionOptions.Ascending && (
                        <i className="body-regular bi-caret-up-fill" />
                      )}
                      {feedbacksFilter.OrderDirection ==
                        CustomerFeedBackListOrderByDirectionOptions.Descending && (
                        <i className="body-regular bi-caret-down-fill"></i>
                      )}
                    </>
                  )}
                </th>
                <th
                  scope="col"
                  onClick={() =>
                    tableHeaderClick(
                      CustomerFeedBackListOrderByOptions.BookingStartTime,
                    )
                  }
                >
                  Varauksen aikaväli{" "}
                  {feedbacksFilter.orderBy ==
                    CustomerFeedBackListOrderByOptions.BookingStartTime && (
                    <>
                      {feedbacksFilter.OrderDirection ==
                        CustomerFeedBackListOrderByDirectionOptions.Ascending && (
                        <i className="bi-caret-up-fill" />
                      )}
                      {feedbacksFilter.OrderDirection ==
                        CustomerFeedBackListOrderByDirectionOptions.Descending && (
                        <i className="bi-caret-down-fill"></i>
                      )}
                    </>
                  )}
                </th>
                <th
                  scope="col"
                  onClick={() =>
                    tableHeaderClick(
                      CustomerFeedBackListOrderByOptions.AccommodationNumber,
                    )
                  }
                >
                  Kohde{" "}
                  {feedbacksFilter.orderBy ==
                    CustomerFeedBackListOrderByOptions.AccommodationNumber && (
                    <>
                      {feedbacksFilter.OrderDirection ==
                        CustomerFeedBackListOrderByDirectionOptions.Ascending && (
                        <i className="text-success body-regular bi-caret-up-fill" />
                      )}
                      {feedbacksFilter.OrderDirection ==
                        CustomerFeedBackListOrderByDirectionOptions.Descending && (
                        <i className="text-success body-regular bi-caret-down-fill"></i>
                      )}
                    </>
                  )}
                </th>
                <th
                  scope="col"
                  onClick={() =>
                    tableHeaderClick(
                      CustomerFeedBackListOrderByOptions.CustomerLastName,
                    )
                  }
                >
                  Asiakas{" "}
                  {feedbacksFilter.orderBy ==
                    CustomerFeedBackListOrderByOptions.CustomerLastName && (
                    <>
                      {feedbacksFilter.OrderDirection ==
                        CustomerFeedBackListOrderByDirectionOptions.Ascending && (
                        <i className="text-success body-regular bi-caret-up-fill" />
                      )}
                      {feedbacksFilter.OrderDirection ==
                        CustomerFeedBackListOrderByDirectionOptions.Descending && (
                        <i className="text-success body-regular bi-caret-down-fill"></i>
                      )}
                    </>
                  )}
                </th>
                <th scope="col" className="col-8">
                  Kommentti
                </th>
              </tr>
            </thead>
            <tbody>{renderFeedBacks()}</tbody>
          </table>
          <PaginationComponent
            OnPageClick={HandlePaginationClick}
            PaginationData={feedbackItemsPagination}
          />
        </div>
      </Layout>
    </div>
  );
};
export default FeedBacksPage;
